module.exports = __webpack_public_path__ + "img/btn-clear.fb4091e5.svg";